import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { IHotelDetails } from '@common-types';
import { getFullAddress, Map } from '@utils';

import MapMarker from '@assets/images/map-bed-marker.svg';

import './style.scss';
import { IGeoLocation } from '@share/common-types';
import { Spin } from 'antd';

interface IProps {
  hotel: IHotelDetails;
  location: IGeoLocation;
  refAnchor: React.RefObject<HTMLDivElement>;
  showBigMap: () => void;
  isVacation: boolean;
}

export function Location(props: IProps) {
  const smallMap: React.RefObject<HTMLDivElement> = React.createRef();
  let smallMapInstance: google.maps.Map | null = null;

  const [mapReady, setMapReady] = useState(false);

  const { hotel, location, refAnchor, showBigMap, isVacation } = props;
  const { id } = hotel;

  useEffect(() => {
    if (smallMap && smallMap.current && location.latitude && location.longitude) {
      const locationToUse = location;

      smallMapInstance = Map.initializeMap(
        smallMap.current,
        Map.getGoogleLocation(locationToUse),
        {
          disableDefaultUI: true,
          disableDoubleClickZoom: true,
          draggable: false,
          clickableIcons: false,
          keyboardShortcuts: false,
        },
      );
      
      google.maps.event.addListenerOnce(smallMapInstance, 'idle', function(){
        setMapReady(true);
      });
        
      setTimeout(() => {
        if (smallMapInstance && !mapReady) {
          setMapReady(true);
        }
      }, 10000);

      Map.addMarkers(smallMapInstance, [{ location: locationToUse, id }], MapMarker);
    }
  }, [smallMap.current, location]);

  const { address, city, countryCode, state, zipCode } = hotel;
  const fullAddress = getFullAddress(address, city, state, zipCode, countryCode);
  const addressStr = fullAddress.join(', ');

  return (
    <div className="location" ref={refAnchor}>
      {
        isVacation
          ?
          <div className="pb-2">
            <div className="rooms-search__list-text secondary-font vacation mb-0">
              <div className="rooms-search__header secondary-font" style={{ fontSize: '24px' }}><FormattedMessage id="tab.map" /></div>
            </div>
          </div>
          : <h4 className="location__tittle"><FormattedMessage id="location" /></h4>
      }

      <div className={`location__wrapper ${isVacation ? 'row' : ''}`}>
        <div className={`location__map-wrapper ${isVacation ? 'vacation col-12 pt-4' : ''}`}>
          <div className={`location__map ${isVacation ? 'vacation' : ''}`} ref={smallMap} />
          {!mapReady && (
            <div className="location__map-loading">
              <Spin size="default" style={{ marginRight: '15px' }} /> loading map...
            </div>)}
          <div className={`location__map-button ${isVacation ? 'vacation' : ''}`} onClick={showBigMap}>
            <FormattedMessage id="view.on.map" />
          </div>
        </div>

        <div className={`location__description-wrapper ${isVacation ? 'col-12' : ''}`}>
          <div className="location__description">
            {hotel.locationDescriptions?.length ? (
              <div>
                <p className="location__title-text">
                  <FormattedMessage id="surrounding.whatsNearby.title" />
                </p>
                {hotel.locationDescriptions.map((description, index) => (
                  <p key={index} className="location__text">
                    {description}
                  </p>
                ))}
              </div>) : null}
          </div>
          <p className="location__address">
            {fullAddress.length ? addressStr : hotel.address}
          </p>
          {hotel.phone && (
            <p className="location__phone">
              <FormattedMessage id="phone" />: {hotel.phone}
            </p>
          )}
        </div>

      </div>
    </div>
  );
}
